import { fetcher } from '@chipinside/fetcher'

const extractFileName = (url?: string) => url?.split('?')[0].split('/').pop() || 'file'

export const fileToURL = (file: File) => URL.createObjectURL(file)

type UrlToFileParams = {
  url: string
  params?: object
}

export async function urlToFile({ params, url }: UrlToFileParams): Promise<File | undefined> {
  try {
    const response = await fetcher({
      axiosOptions: { responseType: 'blob' },
      controller: url,
      params,
    })

    const blob = response?.data as Blob

    return new File([blob], extractFileName(url), { type: blob.type })
  } catch (error) {
    console.error('Erro ao baixar o arquivo:', error)
  }
}

type GetFileURLParams = {
  controller: string
}

export async function getS3URL({ controller }: GetFileURLParams): Promise<string | undefined> {
  try {
    const response = await fetcher({ controller })
    return response?.data as string
  } catch (error) {
    console.error('Erro ao buscar URL do arquivo no S3:', error)
  }
}

export async function getFileBlob({ params, url }: UrlToFileParams): Promise<string> {
  const file = await urlToFile({ params, url })

  return file ? fileToURL(file) : ''
}

type DownloadParams = {
  fileURL: string
  fileName: string
}

export async function download({ fileName, fileURL }: DownloadParams) {
  const link = document.createElement('a')
  link.href = fileURL
  link.download = `cowmed_${fileName}`

  document.body.appendChild(link)
  link.click()
  link.remove()
}

type HandleDownloadParams = {
  controller: string
  fileName?: string
}

export async function handleDownload({ controller, fileName }: HandleDownloadParams) {
  const s3URL = await getS3URL({ controller })
  if (!s3URL) return

  if (!fileName) {
    fileName = extractFileName(s3URL)
  }

  download({ fileName, fileURL: s3URL })
}
